import React from 'react'
import { Heading } from '@myxplor/ui'

import { FormInput } from '@myxplor/forms'
import RemoteTypeAheadSelect from '../../../../ui/forms/type-ahead'

export const UpdateB2BDeviceFormFields = ({ onChange, values, provider_registration_id, mancon_id }) => {

  const getCorrectMancon = (options) => {
    const id = (values.nominated_person) ? values.nominated_person : mancon_id
    // just because react-select is not trigerring onChange when we set the value, not happy with that!
    values.nominated_person = id
    return options.find((option) => (option.value === id))
  }

  return (
    <div>
      <Heading small compact>
        Update B2B Device
      </Heading>

      <fieldset>
        <RemoteTypeAheadSelect
          name='nominated_person'
          label='Nominated Management & Control Personnel ID'
          valueFilter={getCorrectMancon}
          required
          onChange={onChange}
          apiEndPoint={`/api/provider-registrations/${provider_registration_id}/personnel`}
          optionsFilter={options =>
            options.map(({ gov_record }) => ({
              value: gov_record.personID,
              label: `${gov_record.firstName} ${gov_record.lastName} - ${gov_record.personID}`,
            }))
          }
        />
        <FormInput
          name='device_name'
          label='Device Name'
          onChange={onChange}
          required
          value={values.device_name}
        />
        <FormInput
          name='one_time_access_token'
          label='One Time Activation Code'
          onChange={onChange}
          value={values.one_time_access_token}
        />
      </fieldset>

      <p>
        <a
          href='https://www.servicesaustralia.gov.au/organisations/business/services/proda-provider-digital-access/how-manage-your-organisation/managing-b2b-devices'
          rel='noopener noreferrer'
          target='_blank'
        >
          <span>How to obtain a B2B Device activation code</span>
        </a>
      </p>
    </div>
  )
}

export const UpdateB2BDeviceDone = ({payload}) => {
  const expiry = payload.data[0].device_registration.device_expires_at

  return (
    <fieldset>  
      {`Successfully updated B2B Device. New device expires on ${expiry}`}
    </fieldset>
  )
}



// WEBPACK FOOTER //
// ./src/providers-registrations/b2b-device-list/actions/update-action/form.jsx